.diagram {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 12px 12px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface);
  box-shadow: var(--shadow-sm);
}

.hub {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: var(--radius-pill);
  background: var(--color-brand-primary);
  color: var(--color-text-on-brand);
  font-size: 14px;
  font-weight: 700;
}

.hubIcon {
  font-size: 18px;
}

.trunk {
  width: 2px;
  height: 28px;
  background: var(--color-border-strong);
}

.branchRow {
  position: relative;
  display: flex;
  justify-content: center;
  gap: 28px;
  width: 100%;
  flex-wrap: wrap;
  padding-top: 1px;
}

.branchConnector {
  position: absolute;
  top: 0;
  left: 16.6%;
  right: 16.6%;
  height: 2px;
  background: var(--color-border-strong);
}

@media (max-width: 720px) {
  .branchConnector {
    display: none;
  }
}

.branch {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  width: 200px;
}

.stem {
  width: 2px;
  height: 20px;
  background: var(--color-border-strong);
}

.branchCard {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 4px;
  padding: 16px 14px;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  background: var(--color-surface-subtle);
  width: 100%;
}

.branchIcon {
  font-size: 22px;
  color: var(--color-brand-primary);
  margin-bottom: 4px;
}

.branchTitle {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--color-text);
}

.branchSource {
  font-size: 12px;
  color: var(--color-brand-secondary);
  font-weight: 600;
}

.branchDetail {
  font-size: 11.5px;
  color: var(--color-text-tertiary);
}

.footnote {
  text-align: center;
  font-size: 12px;
  color: var(--color-text-tertiary);
  padding-top: 4px;
}
